import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";
import "@/index.css";

// Force light mode only
document.documentElement.classList.remove('dark-mode');
localStorage.setItem('ggdesk-theme', 'light');

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
